export const setProfile = (user) => ({
  type: "SET_PROFILE",
  user,
});
